<template>
  <div class="box box-info">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Leave Entitlement" :visible.sync="displayBasic"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="fiscalYear">Fiscal Year</label>
            <div id="fiscalYear">{{$store.state.fyName}}</div>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="employmentStatus">Employment Status</label>
            <Dropdown v-model="employmentStatusId" :options="employmentStatusList"
                      optionLabel="value" placeholder="Select Employment Status"
                      :filter="true"
                      :showClear="true" id="employmentStatus"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="leaveType">Leave Type</label>
            <Dropdown v-model="leaveTypeId" :options="leaveTypeList" optionLabel="value"
                      placeholder="Select One"
                      :filter="true"
                      :showClear="true" id="leaveType"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="leavePeriod">Leave Period</label>
            <Dropdown v-model="leavePeriodId" :options="leavePeriodList" optionLabel="value"
                      placeholder="Select One"
                      :filter="true"
                      :showClear="true" id="leavePeriod"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Entitlement<span style="color:red">*</span></label>
            <InputText v-model.trim="name"  id="name"/>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addLeaveEntitlement" :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <DataTable :value="leaveEntitlementList" :paginator="true" :rows="8" :filters="filters"
               class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.N">
        <template #body="sl">
          {{sl.index+1}}
        </template>
      </Column>
      <Column header="Name" :sortable="true" field="name"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>
      <Column header="Employement Status" :sortable="true" field="value"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['value']" />
        </template>
      </Column>
      <Column header="Leave Type" :sortable="true" field="value"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['value']" />
        </template>
      </Column>
      <Column header="Leave Period" :sortable="true" field="leavePeriod"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['leavePeriod']" />
        </template>
      </Column>
      <Column header="Entitlement" :sortable="true" field="entitlement"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['entitlement']" />
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editLeaveEntitlement(slotProps.data)" />
          <!--        <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success"-->
          <!--                @click="editSalesOrder(slotProps.data)"/>-->
          <!-- Edit button -->
          <!-- DeleteButton -->
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
          <!--        <Button v-else disabled class="p-button-raised p-button-danger"-->
          <!--                @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>-->
          <!-- Delete Button -->
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteLeaveEntitlement"/>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
export default {
  name: 'leaveEntitlement',
  data() {
    return {
      displayBasic: false,
      name: '',
      employmentStatusId: null,
      leaveTypeId: null,
      leavePeriodId: null,
      loading: false,
      editing: false,
      leaveEntitlementId: null,
      deleteDialog: false,
      filters: {}
    }
  },
  computed: {
    leaveEntitlementList() {
      return this.$store.state.hr.leaveEntitlementList
    },
    employmentStatusList() {
      return this.$store.state.hr.employmentStatusList
    },
    leaveTypeList() {
      return this.$store.state.hr.leaveTypeList
    },
    leavePeriodList() {
      return this.$store.state.hr.leavePeriodList
    }
  },
  mounted() {
    this.findLeaveEntitlementList()
    this.findEmploymentStatusList()
    this.findLeaveTypeList()
    this.findLeavePeriodList()
  },
  methods: {
    async findEmploymentStatusList() {
      await this.$store.dispatch('loadHrMasterSetupList', 'EmployeeStatus')
    },
    async findLeaveTypeList() {
      await this.$store.dispatch('loadHrMasterSetupList', 'LeaveType')
    },
    async findLeaveEntitlementList() {
      await this.$store.dispatch('loadHrMasterSetupList', 'JobTitle')
    },
    async findLeavePeriodList() {
      await this.$store.dispatch('loadLeavePeriodList')
    },
    async addLeaveEntitlement() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let leaveEntitlement = {
        id: this.leaveEntitlementId,
        value: this.name
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', leaveEntitlement)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', leaveEntitlement)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    editLeaveEntitlement(data) {
      this.editing = true
      this.leaveEntitlementId = data.id
      this.name = data.value
      this.openBasic()
    },
    async deleteLeaveEntitlement(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let leaveEntitlement = {
        id: this.leaveEntitlementId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteHrMasterSetup', leaveEntitlement)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Job Title ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    reset() {
      this.name = ''
      this.displayBasic = false
    },
    openDeleteDialog(id) {
      this.leaveEntitlementId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog,
    Dropdown
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// leaveEntitlement.vue?43f88a2c